import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/settlement_discounts',
  component: Management,
  redirect: '/settlement_discounts/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/settlement_discounts/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listSettlementDiscounts
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/settlement_discounts/ListTable'),
          meta: {
            auth: Auth.listSettlementDiscounts,
            tabName: 'all'
          }
        },
        {
          path: 'available',
          component: () => import('@/views/settlement_discounts/ListTable'),
          meta: {
            auth: Auth.listSettlementDiscounts,
            tabName: 'available'
          }
        },
        {
          path: 'expired',
          component: () => import('@/views/settlement_discounts/ListTable'),
          meta: {
            auth: Auth.listSettlementDiscounts,
            tabName: 'expired'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/settlement_discounts/New'),
      meta: {
        auth: Auth.createSettlementDiscount
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/settlement_discounts/Edit'),
      meta: {
        auth: Auth.updateSettlementDiscount
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/settlement_discounts/DetailLayout'),
      meta: {
        auth: Auth.showSettlementDiscount
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/settlement_discounts/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showSettlementDiscount
          }
        }
      ]
    }
  ]
}
